import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Barchart icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Barchart } from '@sravni/design-system-icons'
 *
 * <Barchart />
 * ```
 */
var Barchart = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Barchart", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.435 15.714V8.572M15.935 15.714v-10M8.936 15.714V4.286M5.436 15.714v-2.857", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Barchart };
//# sourceMappingURL=Barchart.js.map
